import { render } from "./BayesianAnalysis.vue?vue&type=template&id=3951d6b4&scoped=true"
import script from "./BayesianAnalysis.vue?vue&type=script&lang=js"
export * from "./BayesianAnalysis.vue?vue&type=script&lang=js"

import "./BayesianAnalysis.vue?vue&type=style&index=0&id=3951d6b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3951d6b4"]])

export default __exports__